import request from '@/utils/ajax';
//启机注册
export function registerAlive(data: { unique_identifier: string }) {
  return request.request<[], HttpResponse<[]>>({
    url: '/startup/getInfo',
    method: 'post',
    data: data,
  });
}
